import React from 'react';
import { useHistory } from 'react-router-dom';
import { EmptyState, Flex } from '@bynder/design-system';
import { Translate, useTranslate } from '@bynder/localization';
import InternalServerErrorSVG from '../../assets/internal_server_error.svg?raw';
import { ROUTES } from '../../constants/app';
import PrimaryButton from '../shared/PrimaryButton';
import { svgtob64 } from '../../helpers/utils';
import FullScreenContainer from '../shared/styled-components/FullScreenContainer';

type Props = {
  isRefresh?: boolean;
};

const InternalServerError: React.FC<Props> = ({ isRefresh }) => {
  const { translate } = useTranslate();
  const history = useHistory();

  return (
    <FullScreenContainer>
      <Flex direction="column" justifyContent="center" alignItems="center">
        <img
          src={svgtob64(InternalServerErrorSVG)}
          alt={translate('INTERNAL_SERVER_ERROR.IMG_ALT')}
        />
        <EmptyState
          title={<Translate id="INTERNAL_SERVER_ERROR.HEADER_TEXT" />}
          text={<Translate id="INTERNAL_SERVER_ERROR.PARAGRAPH_TEXT" />}
          actions={
            isRefresh ? (
              <PrimaryButton onClick={() => window.location.reload()}>
                <Translate id="INTERNAL_SERVER_ERROR.REFRESH_BUTTON_TEXT" />
              </PrimaryButton>
            ) : (
              <PrimaryButton
                onClick={() => history.push(ROUTES.GUIDE_OVERVIEW)}
              >
                <Translate id="INTERNAL_SERVER_ERROR.BUTTON_TEXT" />
              </PrimaryButton>
            )
          }
        />
      </Flex>
    </FullScreenContainer>
  );
};

export default InternalServerError;
